import { A4uDelete as IconComponent } from '@adobe/react-spectrum-workflow/dist/Delete.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Delete(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}